export default () => {
  const headlines = document.querySelectorAll('[component="feature-card"]');

  headlines.forEach((headline) => {
    const buttonChild = headline.querySelector('[child="button"]');

    if (buttonChild) {
      const { link } = buttonChild.dataset;

      if (!link) {
        buttonChild.remove();
      }
    }
  });
};
